import endpoints from "hooks/api/endpoints";
import useApiGet from "hooks/api/useApiGet";
import useProjectEndpoint from "hooks/useProjectEndpoint";
import { useMemo } from "react";
import ParticipantDto from "types/ParticipantDto";
import ParticipantsResponseDto from "types/ParticipantsResponseDto";

interface Params {
  includeScripts?: boolean;
  orderBy?: keyof ParticipantDto;
}

export default function useGetParticipants(params?: Params) {
  const { result, ...rest } = useApiGet<ParticipantsResponseDto>(
    useProjectEndpoint(endpoints.getAllParticipants, {
      includeScripts:
        params?.includeScripts != undefined ? params.includeScripts : true,
      searchable: params?.orderBy === "searchable" || true,
    }),
  );

  const participantsById = useMemo(() => {
    if (result) {
      let dataList = result.dataList;
      const orderBy = params?.orderBy;
      if (orderBy && orderBy !== "searchable") {
        dataList = [...result.dataList].sort((a, b) =>
          a[orderBy] > b[orderBy] ? 1 : -1,
        );
      }

      return dataList.reduce((prev, participant) => {
        prev[participant.id] = participant;
        return prev;
      }, {});
    }
    return {};
  }, [result]) as { [id: string]: ParticipantDto };

  return {
    participants: result?.dataList,
    participantsById,
    ...rest,
  };
}
